import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class PaymentTermReferenceService extends BaseReferenceService {
  constructor() {
    super('PaymentTermReference');
  }
}
